export default (title, subtitle, series, onSliceClick, mainColor, secondaryColor, percentage) => {
	return {
		type: 'pie',
		// backgroundColor: '#2B313B',
		title: {
			text: title,
			align: 'left',
			// fontColor: '#fff',
			fontFamily: 'Open Sans',
			fontSize: '25px',
			offsetX: '10px'
		},
		subtitle: {
			text: subtitle,
			align: 'left',
			fontColor: '#8e99a9',
			fontFamily: 'Open Sans',
			fontSize: '16px',
			offsetX: '10px',
			offsetY: '10px'
		},
		plot: {
			// cursor: 'pointer',
			// events: {
			// 	plot_click: (e) => {
			// 		if (onSliceClick) {
			// 			onSliceClick(e.text)
			// 		}
			// 	}
			// },
			tooltip: {
				text: '%npv%',
				padding: '5px 10px',
				fontFamily: 'Open Sans',
				fontSize: '18px'
			},
			valueBox: {
				// text: '%t\n%npv%',
				text: '%t\n%v (%npv%)',
				fontFamily: 'Open Sans',
				placement: 'out'
			},
			animation: {
				effect: 'ANIMATION_EXPAND_VERTICAL',
				method: 'ANIMATION_REGULAR_EASE_OUT',
				sequence: 'ANIMATION_BY_PLOT',
				speed: 500
			}
			// borderColor: '#2B313B',
			// borderWidth: '5px'
		},
		plotarea: {
			margin: '20px 0 0 0'
		},
		source: {
			text: 'Source: gs.statcounter.com',
			fontColor: '#8e99a9',
			fontFamily: 'Open Sans',
			textAlign: 'left'
		},
		series: series ? series : []
	}
}
